<template>
<div class="login-box">
  <div class="login-header">
    <slot></slot>
    <h1 class="f16" v-html="tipsText || '登录后即可免费畅玩'"></h1>
  </div>
  <p>请输入你的手机号码</p>
  <baseinput
      :error="tip"
      :min="0"
      :max="14"
      type="tel"
      placeholder="请输入手机号码"
      v-model.trim="cphone"
      v-on:input="onInput"
      v-on:keyup.enter="setNext"
    >
      <div @click.stop.prevent="onShowregion" class="login-region f12" slot="before"><span>{{cregion}}</span><i class="icon icon-back2"></i></div>
      <template slot="after" v-if="showregion">
        <ul class="login-regions">
          <li  v-for="item in list" :key='item._id' @click.stop.prevent="setRegion(item.code)" class="f12">{{item.code}} {{item.name}}</li>
        </ul>
      </template>
    </baseinput>
  <div class="g-Btn g-Btn-green2" @click="setNext">{{nextText || '下一步'}}</div>

</div>
</template>

<script>
import baseinput from '@/components/input/input'
export default {
  name: 'loginphone',
  props: {
    phone: String,
    region: [String, Number],
    codes: {
      type: Array,
      default: () => {
        return []
      }
    },
    tipsText: String,
    nextText: String
  },
  data () {
    return {
      error: '请输入正确的手机号码',
      cphone: '',
      tip: '',
      showregion: false,
      cregion: 86,
      list: this.codes
    }
  },
  created () {
    this.cphone = this.phone
    this.cregion = this.region
  },
  components: {
    baseinput
  },
  computed: {
  },
  watch: {
    codes ()  {
      this.list = this.codes
    }
  },
  methods: {
    isMobile (mobile) {
      return /[0-9]{0,14}$/.test(mobile)
    },
    onInput () {
      if (this.cphone.length === 11) {
        if (!this.isMobile(this.cphone)) {
          this.tip = this.error
        }
      }
      this.tip = ''
    },
    setNext () {
      this.$store.dispatch('postBehaviors', {
            action: 'page_login_next'
      })
      this.onHideregion()
      if (this.cphone && this.isMobile(this.cregion + this.cphone)) {
        this.$emit('setPhone', {
          phone: this.cphone,
          region: this.cregion
        })
      } else {
        this.tip = this.error
      }
    },
    setRegion(code) {
      this.cregion = code
      this.tip = ''
      this.onHideregion()
      return false
    },
    setError (msg) {
      this.tip = msg || '当前号码无效，不可使用'
    },
    onShowregion () {
      this.showregion = true
      return false
    },
    onHideregion () {
      this.showregion = false
      return false
    }
  },
  mounted () {
    document.body.addEventListener('click', this.onHideregion)
  },
  destroyed () {
    document.body.removeEventListener('click', this.onHideregion)
  }
}
</script>
